export enum IdentityDocumentTypeEnum {
  Passeport = 'Passeport',
  IdentityCard = 'IdentityCard',
}

export const allIdentityDocumentTypes = Object.keys(IdentityDocumentTypeEnum);